export class RoofItemType {
    senItemID?: number;
    code: string;
    quantity: number;

    constructor(senItemID: number, code: string, amount: number) {
        this.senItemID = senItemID;
        this.code = code;
        this.quantity = amount;
    }
}
